
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import {ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseUrl from '../Config';

const SuperAdminLogin = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);  
  const navigate = useNavigate();
  const location = useLocation();
  
  const { email, password, rememberMe } = formData;
  
  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({ ...formData, [e.target.name]: value });
  };
  
  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ email, password });

    const res = await axios.post(`${baseUrl}/superadmin/login`, body, config);
    console.log('Login response:', res.data);

    if (res.data.success) {
      const { token, role } = res.data.data;

      console.log('Received token:', token);
      console.log('User role:', role);

      // Store in sessionStorage
      sessionStorage.setItem('token', token);
      sessionStorage.setItem('role', 'superadmin'); // since this is superadmin login

      // Show toast
      toast.success('Login successful!', {
        position: "top-right",
        autoClose: 3000,
      });

      // Navigate to dashboard
      navigate('/super-admin-dashboard');
    }
  } catch (err) {
    const status = err.response?.status;

    if (status === 404) {
      toast.error('User not found', { position: "top-right", autoClose: 3000 });
    } else if (status === 401) {
      toast.error('Invalid email or password', { position: "top-right", autoClose: 3000 });
    } else if (status === 403) {
      toast.error('Admin access required', { position: "top-right", autoClose: 3000 });
    } else {
      toast.error(err.response?.data?.error || 'Login failed', { position: "top-right", autoClose: 3000 });
    }
  } finally {
    setLoading(false);
  }
};
  
  return (
    <div className="flex justify-center items-center py-12">
         <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-md">
                <div className="text-center mb-6">
  <h1 className="text-2xl font-bold">Super Admin Login</h1>
  <p className="text-sm text-gray-500 mt-1">Only accessible by the company owner or system administrator</p>
</div>
        
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4" role="alert">
            <span className="block sm:inline">{error}</span>
          </div>
        )}
        
        <form onSubmit={handleFormSubmit} noValidate>
        <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              placeholder="Enter your email"
              required
            />
          </div>

           <div className="mb-6 relative">
      <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
        Password
      </label>
      <div className="relative">
        <input
          type={showPassword ? "text" : "password"}
          id="password"
          name="password"
          value={password}
          onChange={handleChange}
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline pr-10"
          placeholder="Enter your password"
          required
        />
        <button
          type="button"
          className="absolute right-3 top-2.5 text-gray-500 hover:text-gray-700 focus:outline-none"
           onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
            </svg>
          )}
        </button>
      </div>
    </div>
          
          <div className="flex items-center mb-6">
            <input
              type="checkbox"
              id="rememberMe"
              name="rememberMe"
              checked={rememberMe}
              onChange={handleChange}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label className="ml-2 block text-sm text-gray-900" htmlFor="rememberMe">
              Remember me
            </label>
          </div>
          
          <div className="mb-6">
            <button
              type="submit"
              className="w-full bg-[#86c232] hover:bg-[#76ae2c] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Sign In'}
            </button>
          </div>
          
          
          <div className="text-center">
           
           {/* <p className="text-gray-600 mt-2">
             <Link
               to="/forgot-password"
               className="relative inline-block text-[#86C232] transition-all duration-300 ease-in-out hover:text-[#86C232] after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full after:h-[2px] after:bg-[#86C232] after:scale-x-0 hover:after:scale-x-100 after:origin-left after:transition-transform after:duration-300"
             >
               Forgot your password?
             </Link>
           </p> */}
          </div>
        </form>
      </div>
    </div>
  );
};

export default SuperAdminLogin;


